// Admin API for the WhatsApp Batch Message Service.
//
// This is NOT part of the BMI surface. It is authenticated with an admin
// session cookie established by Login, never with a CLIENT bearer token, and
// it is served on a separate Connect service so the two can never be confused.
//
// Everything here is outside the scope of the BMI specification: SPEC.md §1.2
// explicitly puts token minting and administration out of scope.

// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file wabms/admin/v1/admin.proto (package wabms.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Batch, BatchStatus, Message as Message$1, MessageError, MessageState } from "../../../bmi/v1/batch_message_pb";
import { file_bmi_v1_batch_message } from "../../../bmi/v1/batch_message_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wabms/admin/v1/admin.proto.
 */
export const file_wabms_admin_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bmi_v1_batch_message, file_google_protobuf_timestamp]);

/**
 * @generated from message wabms.admin.v1.LoginRequest
 */
export type LoginRequest = Message<"wabms.admin.v1.LoginRequest"> & {
  /**
   * @generated from field: string passphrase = 1;
   */
  passphrase: string;
};

/**
 * Describes the message wabms.admin.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 0);

/**
 * @generated from message wabms.admin.v1.LoginResponse
 */
export type LoginResponse = Message<"wabms.admin.v1.LoginResponse"> & {
  /**
   * The session cookie is set by the server; this is metadata only.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 1;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 1);

/**
 * @generated from message wabms.admin.v1.LogoutRequest
 */
export type LogoutRequest = Message<"wabms.admin.v1.LogoutRequest"> & {
};

/**
 * Describes the message wabms.admin.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 2);

/**
 * @generated from message wabms.admin.v1.LogoutResponse
 */
export type LogoutResponse = Message<"wabms.admin.v1.LogoutResponse"> & {
};

/**
 * Describes the message wabms.admin.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 3);

/**
 * @generated from message wabms.admin.v1.WhoAmIRequest
 */
export type WhoAmIRequest = Message<"wabms.admin.v1.WhoAmIRequest"> & {
};

/**
 * Describes the message wabms.admin.v1.WhoAmIRequest.
 * Use `create(WhoAmIRequestSchema)` to create a new message.
 */
export const WhoAmIRequestSchema: GenMessage<WhoAmIRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 4);

/**
 * @generated from message wabms.admin.v1.WhoAmIResponse
 */
export type WhoAmIResponse = Message<"wabms.admin.v1.WhoAmIResponse"> & {
  /**
   * @generated from field: bool authenticated = 1;
   */
  authenticated: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * Full git commit SHA the running binary was built from, stamped at build
   * time. Empty when the build did not stamp one, and always empty for an
   * unauthenticated caller: which build is deployed is operator information.
   *
   * @generated from field: string build_commit = 3;
   */
  buildCommit: string;
};

/**
 * Describes the message wabms.admin.v1.WhoAmIResponse.
 * Use `create(WhoAmIResponseSchema)` to create a new message.
 */
export const WhoAmIResponseSchema: GenMessage<WhoAmIResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 5);

/**
 * @generated from message wabms.admin.v1.AdminSession
 */
export type AdminSession = Message<"wabms.admin.v1.AdminSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_seen_at = 4;
   */
  lastSeenAt?: Timestamp | undefined;

  /**
   * @generated from field: string user_agent = 5;
   */
  userAgent: string;

  /**
   * @generated from field: string ip = 6;
   */
  ip: string;

  /**
   * True for the session making this call.
   *
   * @generated from field: bool current = 7;
   */
  current: boolean;
};

/**
 * Describes the message wabms.admin.v1.AdminSession.
 * Use `create(AdminSessionSchema)` to create a new message.
 */
export const AdminSessionSchema: GenMessage<AdminSession> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 6);

/**
 * @generated from message wabms.admin.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"wabms.admin.v1.ListSessionsRequest"> & {
};

/**
 * Describes the message wabms.admin.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 7);

/**
 * @generated from message wabms.admin.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"wabms.admin.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated wabms.admin.v1.AdminSession sessions = 1;
   */
  sessions: AdminSession[];
};

/**
 * Describes the message wabms.admin.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 8);

/**
 * @generated from message wabms.admin.v1.RevokeSessionRequest
 */
export type RevokeSessionRequest = Message<"wabms.admin.v1.RevokeSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message wabms.admin.v1.RevokeSessionRequest.
 * Use `create(RevokeSessionRequestSchema)` to create a new message.
 */
export const RevokeSessionRequestSchema: GenMessage<RevokeSessionRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 9);

/**
 * @generated from message wabms.admin.v1.RevokeSessionResponse
 */
export type RevokeSessionResponse = Message<"wabms.admin.v1.RevokeSessionResponse"> & {
};

/**
 * Describes the message wabms.admin.v1.RevokeSessionResponse.
 * Use `create(RevokeSessionResponseSchema)` to create a new message.
 */
export const RevokeSessionResponseSchema: GenMessage<RevokeSessionResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 10);

/**
 * @generated from message wabms.admin.v1.RevokeAllSessionsRequest
 */
export type RevokeAllSessionsRequest = Message<"wabms.admin.v1.RevokeAllSessionsRequest"> & {
  /**
   * Keep the calling session alive.
   *
   * @generated from field: bool except_current = 1;
   */
  exceptCurrent: boolean;
};

/**
 * Describes the message wabms.admin.v1.RevokeAllSessionsRequest.
 * Use `create(RevokeAllSessionsRequestSchema)` to create a new message.
 */
export const RevokeAllSessionsRequestSchema: GenMessage<RevokeAllSessionsRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 11);

/**
 * @generated from message wabms.admin.v1.RevokeAllSessionsResponse
 */
export type RevokeAllSessionsResponse = Message<"wabms.admin.v1.RevokeAllSessionsResponse"> & {
  /**
   * @generated from field: int32 revoked_count = 1;
   */
  revokedCount: number;
};

/**
 * Describes the message wabms.admin.v1.RevokeAllSessionsResponse.
 * Use `create(RevokeAllSessionsResponseSchema)` to create a new message.
 */
export const RevokeAllSessionsResponseSchema: GenMessage<RevokeAllSessionsResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 12);

/**
 * @generated from message wabms.admin.v1.SendPolicy
 */
export type SendPolicy = Message<"wabms.admin.v1.SendPolicy"> & {
  /**
   * @generated from field: int32 msgs_per_minute = 1;
   */
  msgsPerMinute: number;

  /**
   * @generated from field: int32 min_gap_ms = 2;
   */
  minGapMs: number;

  /**
   * @generated from field: int32 jitter_ms = 3;
   */
  jitterMs: number;

  /**
   * @generated from field: int32 daily_cap = 4;
   */
  dailyCap: number;

  /**
   * @generated from field: bool paused = 5;
   */
  paused: boolean;

  /**
   * @generated from field: string paused_reason = 6;
   */
  pausedReason: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp warmup_started_at = 7;
   */
  warmupStartedAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.SendPolicy.
 * Use `create(SendPolicySchema)` to create a new message.
 */
export const SendPolicySchema: GenMessage<SendPolicy> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 13);

/**
 * @generated from message wabms.admin.v1.WebhookConfig
 */
export type WebhookConfig = Message<"wabms.admin.v1.WebhookConfig"> & {
  /**
   * @generated from field: string default_url = 1;
   */
  defaultUrl: string;

  /**
   * @generated from field: repeated string allowed_url_prefixes = 2;
   */
  allowedUrlPrefixes: string[];

  /**
   * @generated from field: bool secret_set = 3;
   */
  secretSet: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp disabled_at = 4;
   */
  disabledAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 consecutive_failures = 5;
   */
  consecutiveFailures: number;
};

/**
 * Describes the message wabms.admin.v1.WebhookConfig.
 * Use `create(WebhookConfigSchema)` to create a new message.
 */
export const WebhookConfigSchema: GenMessage<WebhookConfig> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 14);

/**
 * @generated from message wabms.admin.v1.Account
 */
export type Account = Message<"wabms.admin.v1.Account"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: wabms.admin.v1.AccountStatus status = 3;
   */
  status: AccountStatus;

  /**
   * Populated once paired.
   *
   * @generated from field: string jid = 4;
   */
  jid: string;

  /**
   * @generated from field: string lid = 5;
   */
  lid: string;

  /**
   * @generated from field: string phone_e164 = 6;
   */
  phoneE164: string;

  /**
   * @generated from field: string push_name = 7;
   */
  pushName: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp paired_at = 8;
   */
  pairedAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_connected_at = 9;
   */
  lastConnectedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: wabms.admin.v1.SendPolicy send_policy = 11;
   */
  sendPolicy?: SendPolicy | undefined;

  /**
   * @generated from field: wabms.admin.v1.WebhookConfig webhook = 12;
   */
  webhook?: WebhookConfig | undefined;

  /**
   * Non-terminal messages currently waiting for this account.
   *
   * @generated from field: int32 queue_depth = 13;
   */
  queueDepth: number;

  /**
   * Messages that reached SENT today, against SendPolicy.daily_cap.
   *
   * @generated from field: int32 sent_today = 14;
   */
  sentToday: number;
};

/**
 * Describes the message wabms.admin.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 15);

/**
 * @generated from message wabms.admin.v1.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"wabms.admin.v1.ListAccountsRequest"> & {
};

/**
 * Describes the message wabms.admin.v1.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 16);

/**
 * @generated from message wabms.admin.v1.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"wabms.admin.v1.ListAccountsResponse"> & {
  /**
   * @generated from field: repeated wabms.admin.v1.Account accounts = 1;
   */
  accounts: Account[];
};

/**
 * Describes the message wabms.admin.v1.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 17);

/**
 * @generated from message wabms.admin.v1.GetAccountRequest
 */
export type GetAccountRequest = Message<"wabms.admin.v1.GetAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 18);

/**
 * @generated from message wabms.admin.v1.GetAccountResponse
 */
export type GetAccountResponse = Message<"wabms.admin.v1.GetAccountResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema: GenMessage<GetAccountResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 19);

/**
 * @generated from message wabms.admin.v1.PairAccountRequest
 */
export type PairAccountRequest = Message<"wabms.admin.v1.PairAccountRequest"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: wabms.admin.v1.PairMethod method = 2;
   */
  method: PairMethod;

  /**
   * Required iff method == PAIR_METHOD_PHONE_CODE. E.164, no leading +.
   *
   * @generated from field: string phone_number = 3;
   */
  phoneNumber: string;
};

/**
 * Describes the message wabms.admin.v1.PairAccountRequest.
 * Use `create(PairAccountRequestSchema)` to create a new message.
 */
export const PairAccountRequestSchema: GenMessage<PairAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 20);

/**
 * @generated from message wabms.admin.v1.PairAccountUpdate
 */
export type PairAccountUpdate = Message<"wabms.admin.v1.PairAccountUpdate"> & {
  /**
   * @generated from oneof wabms.admin.v1.PairAccountUpdate.update
   */
  update: {
    /**
     * Raw QR payload; the SPA renders it. Rotates roughly every 20 seconds.
     *
     * @generated from field: string qr_code = 1;
     */
    value: string;
    case: "qrCode";
  } | {
    /**
     * 8-character code the operator types on their phone.
     *
     * @generated from field: string linking_code = 2;
     */
    value: string;
    case: "linkingCode";
  } | {
    /**
     * @generated from field: wabms.admin.v1.Account paired = 3;
     */
    value: Account;
    case: "paired";
  } | {
    /**
     * @generated from field: string error = 4;
     */
    value: string;
    case: "error";
  } | {
    /**
     * The pairing window elapsed without a scan.
     *
     * @generated from field: bool timeout = 5;
     */
    value: boolean;
    case: "timeout";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message wabms.admin.v1.PairAccountUpdate.
 * Use `create(PairAccountUpdateSchema)` to create a new message.
 */
export const PairAccountUpdateSchema: GenMessage<PairAccountUpdate> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 21);

/**
 * @generated from message wabms.admin.v1.ReconnectAccountRequest
 */
export type ReconnectAccountRequest = Message<"wabms.admin.v1.ReconnectAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.ReconnectAccountRequest.
 * Use `create(ReconnectAccountRequestSchema)` to create a new message.
 */
export const ReconnectAccountRequestSchema: GenMessage<ReconnectAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 22);

/**
 * @generated from message wabms.admin.v1.ReconnectAccountResponse
 */
export type ReconnectAccountResponse = Message<"wabms.admin.v1.ReconnectAccountResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.ReconnectAccountResponse.
 * Use `create(ReconnectAccountResponseSchema)` to create a new message.
 */
export const ReconnectAccountResponseSchema: GenMessage<ReconnectAccountResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 23);

/**
 * @generated from message wabms.admin.v1.DisconnectAccountRequest
 */
export type DisconnectAccountRequest = Message<"wabms.admin.v1.DisconnectAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.DisconnectAccountRequest.
 * Use `create(DisconnectAccountRequestSchema)` to create a new message.
 */
export const DisconnectAccountRequestSchema: GenMessage<DisconnectAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 24);

/**
 * @generated from message wabms.admin.v1.DisconnectAccountResponse
 */
export type DisconnectAccountResponse = Message<"wabms.admin.v1.DisconnectAccountResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.DisconnectAccountResponse.
 * Use `create(DisconnectAccountResponseSchema)` to create a new message.
 */
export const DisconnectAccountResponseSchema: GenMessage<DisconnectAccountResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 25);

/**
 * @generated from message wabms.admin.v1.LogoutAccountRequest
 */
export type LogoutAccountRequest = Message<"wabms.admin.v1.LogoutAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.LogoutAccountRequest.
 * Use `create(LogoutAccountRequestSchema)` to create a new message.
 */
export const LogoutAccountRequestSchema: GenMessage<LogoutAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 26);

/**
 * @generated from message wabms.admin.v1.LogoutAccountResponse
 */
export type LogoutAccountResponse = Message<"wabms.admin.v1.LogoutAccountResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.LogoutAccountResponse.
 * Use `create(LogoutAccountResponseSchema)` to create a new message.
 */
export const LogoutAccountResponseSchema: GenMessage<LogoutAccountResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 27);

/**
 * @generated from message wabms.admin.v1.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"wabms.admin.v1.DeleteAccountRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 28);

/**
 * @generated from message wabms.admin.v1.DeleteAccountResponse
 */
export type DeleteAccountResponse = Message<"wabms.admin.v1.DeleteAccountResponse"> & {
};

/**
 * Describes the message wabms.admin.v1.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema: GenMessage<DeleteAccountResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 29);

/**
 * @generated from message wabms.admin.v1.UpdateSendPolicyRequest
 */
export type UpdateSendPolicyRequest = Message<"wabms.admin.v1.UpdateSendPolicyRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: wabms.admin.v1.SendPolicy send_policy = 2;
   */
  sendPolicy?: SendPolicy | undefined;
};

/**
 * Describes the message wabms.admin.v1.UpdateSendPolicyRequest.
 * Use `create(UpdateSendPolicyRequestSchema)` to create a new message.
 */
export const UpdateSendPolicyRequestSchema: GenMessage<UpdateSendPolicyRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 30);

/**
 * @generated from message wabms.admin.v1.UpdateSendPolicyResponse
 */
export type UpdateSendPolicyResponse = Message<"wabms.admin.v1.UpdateSendPolicyResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.UpdateSendPolicyResponse.
 * Use `create(UpdateSendPolicyResponseSchema)` to create a new message.
 */
export const UpdateSendPolicyResponseSchema: GenMessage<UpdateSendPolicyResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 31);

/**
 * @generated from message wabms.admin.v1.UpdateWebhookConfigRequest
 */
export type UpdateWebhookConfigRequest = Message<"wabms.admin.v1.UpdateWebhookConfigRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string default_url = 2;
   */
  defaultUrl: string;

  /**
   * @generated from field: repeated string allowed_url_prefixes = 3;
   */
  allowedUrlPrefixes: string[];

  /**
   * Clears disabled_at and the failure counter.
   *
   * @generated from field: bool reenable = 4;
   */
  reenable: boolean;
};

/**
 * Describes the message wabms.admin.v1.UpdateWebhookConfigRequest.
 * Use `create(UpdateWebhookConfigRequestSchema)` to create a new message.
 */
export const UpdateWebhookConfigRequestSchema: GenMessage<UpdateWebhookConfigRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 32);

/**
 * @generated from message wabms.admin.v1.UpdateWebhookConfigResponse
 */
export type UpdateWebhookConfigResponse = Message<"wabms.admin.v1.UpdateWebhookConfigResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Account account = 1;
   */
  account?: Account | undefined;
};

/**
 * Describes the message wabms.admin.v1.UpdateWebhookConfigResponse.
 * Use `create(UpdateWebhookConfigResponseSchema)` to create a new message.
 */
export const UpdateWebhookConfigResponseSchema: GenMessage<UpdateWebhookConfigResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 33);

/**
 * @generated from message wabms.admin.v1.RotateWebhookSecretRequest
 */
export type RotateWebhookSecretRequest = Message<"wabms.admin.v1.RotateWebhookSecretRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.RotateWebhookSecretRequest.
 * Use `create(RotateWebhookSecretRequestSchema)` to create a new message.
 */
export const RotateWebhookSecretRequestSchema: GenMessage<RotateWebhookSecretRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 34);

/**
 * @generated from message wabms.admin.v1.RotateWebhookSecretResponse
 */
export type RotateWebhookSecretResponse = Message<"wabms.admin.v1.RotateWebhookSecretResponse"> & {
  /**
   * Shown once. Not recoverable afterwards.
   *
   * @generated from field: string secret = 1;
   */
  secret: string;
};

/**
 * Describes the message wabms.admin.v1.RotateWebhookSecretResponse.
 * Use `create(RotateWebhookSecretResponseSchema)` to create a new message.
 */
export const RotateWebhookSecretResponseSchema: GenMessage<RotateWebhookSecretResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 35);

/**
 * @generated from message wabms.admin.v1.Group
 */
export type Group = Message<"wabms.admin.v1.Group"> & {
  /**
   * Full group JID, e.g. "120363012345678901@g.us".
   *
   * @generated from field: string wa_id = 1;
   */
  waId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 participant_count = 3;
   */
  participantCount: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * True when the row is a community parent rather than a chat group.
   *
   * @generated from field: bool is_community = 5;
   */
  isCommunity: boolean;

  /**
   * Set when the group is linked into a community.
   *
   * @generated from field: string parent_wa_id = 6;
   */
  parentWaId: string;

  /**
   * Only admins may post.
   *
   * @generated from field: bool announce_only = 7;
   */
  announceOnly: boolean;
};

/**
 * Describes the message wabms.admin.v1.Group.
 * Use `create(GroupSchema)` to create a new message.
 */
export const GroupSchema: GenMessage<Group> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 36);

/**
 * @generated from message wabms.admin.v1.ListGroupsRequest
 */
export type ListGroupsRequest = Message<"wabms.admin.v1.ListGroupsRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.ListGroupsRequest.
 * Use `create(ListGroupsRequestSchema)` to create a new message.
 */
export const ListGroupsRequestSchema: GenMessage<ListGroupsRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 37);

/**
 * @generated from message wabms.admin.v1.ListGroupsResponse
 */
export type ListGroupsResponse = Message<"wabms.admin.v1.ListGroupsResponse"> & {
  /**
   * @generated from field: repeated wabms.admin.v1.Group groups = 1;
   */
  groups: Group[];

  /**
   * When the TARGET answered. The SPA stamps the CSV filename with it.
   *
   * @generated from field: google.protobuf.Timestamp fetched_at = 2;
   */
  fetchedAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.ListGroupsResponse.
 * Use `create(ListGroupsResponseSchema)` to create a new message.
 */
export const ListGroupsResponseSchema: GenMessage<ListGroupsResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 38);

/**
 * @generated from message wabms.admin.v1.Token
 */
export type Token = Message<"wabms.admin.v1.Token"> & {
  /**
   * @generated from field: string token_id = 1;
   */
  tokenId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Display-only leading characters of the token, for identification.
   *
   * @generated from field: string prefix = 4;
   */
  prefix: string;

  /**
   * @generated from field: repeated string scopes = 5;
   */
  scopes: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_used_at = 8;
   */
  lastUsedAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 9;
   */
  revokedAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 39);

/**
 * @generated from message wabms.admin.v1.ListTokensRequest
 */
export type ListTokensRequest = Message<"wabms.admin.v1.ListTokensRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.ListTokensRequest.
 * Use `create(ListTokensRequestSchema)` to create a new message.
 */
export const ListTokensRequestSchema: GenMessage<ListTokensRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 40);

/**
 * @generated from message wabms.admin.v1.ListTokensResponse
 */
export type ListTokensResponse = Message<"wabms.admin.v1.ListTokensResponse"> & {
  /**
   * @generated from field: repeated wabms.admin.v1.Token tokens = 1;
   */
  tokens: Token[];
};

/**
 * Describes the message wabms.admin.v1.ListTokensResponse.
 * Use `create(ListTokensResponseSchema)` to create a new message.
 */
export const ListTokensResponseSchema: GenMessage<ListTokensResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 41);

/**
 * @generated from message wabms.admin.v1.CreateTokenRequest
 */
export type CreateTokenRequest = Message<"wabms.admin.v1.CreateTokenRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Any of: service:read, batches:read, batches:write.
   *
   * @generated from field: repeated string scopes = 3;
   */
  scopes: string[];

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.CreateTokenRequest.
 * Use `create(CreateTokenRequestSchema)` to create a new message.
 */
export const CreateTokenRequestSchema: GenMessage<CreateTokenRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 42);

/**
 * @generated from message wabms.admin.v1.CreateTokenResponse
 */
export type CreateTokenResponse = Message<"wabms.admin.v1.CreateTokenResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Token token = 1;
   */
  token?: Token | undefined;

  /**
   * Plaintext, returned exactly once.
   *
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message wabms.admin.v1.CreateTokenResponse.
 * Use `create(CreateTokenResponseSchema)` to create a new message.
 */
export const CreateTokenResponseSchema: GenMessage<CreateTokenResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 43);

/**
 * @generated from message wabms.admin.v1.RevokeTokenRequest
 */
export type RevokeTokenRequest = Message<"wabms.admin.v1.RevokeTokenRequest"> & {
  /**
   * @generated from field: string token_id = 1;
   */
  tokenId: string;
};

/**
 * Describes the message wabms.admin.v1.RevokeTokenRequest.
 * Use `create(RevokeTokenRequestSchema)` to create a new message.
 */
export const RevokeTokenRequestSchema: GenMessage<RevokeTokenRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 44);

/**
 * @generated from message wabms.admin.v1.RevokeTokenResponse
 */
export type RevokeTokenResponse = Message<"wabms.admin.v1.RevokeTokenResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.Token token = 1;
   */
  token?: Token | undefined;
};

/**
 * Describes the message wabms.admin.v1.RevokeTokenResponse.
 * Use `create(RevokeTokenResponseSchema)` to create a new message.
 */
export const RevokeTokenResponseSchema: GenMessage<RevokeTokenResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 45);

/**
 * @generated from message wabms.admin.v1.DeleteTokenRequest
 */
export type DeleteTokenRequest = Message<"wabms.admin.v1.DeleteTokenRequest"> & {
  /**
   * @generated from field: string token_id = 1;
   */
  tokenId: string;
};

/**
 * Describes the message wabms.admin.v1.DeleteTokenRequest.
 * Use `create(DeleteTokenRequestSchema)` to create a new message.
 */
export const DeleteTokenRequestSchema: GenMessage<DeleteTokenRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 46);

/**
 * @generated from message wabms.admin.v1.DeleteTokenResponse
 */
export type DeleteTokenResponse = Message<"wabms.admin.v1.DeleteTokenResponse"> & {
};

/**
 * Describes the message wabms.admin.v1.DeleteTokenResponse.
 * Use `create(DeleteTokenResponseSchema)` to create a new message.
 */
export const DeleteTokenResponseSchema: GenMessage<DeleteTokenResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 47);

/**
 * @generated from message wabms.admin.v1.AdminListBatchesRequest
 */
export type AdminListBatchesRequest = Message<"wabms.admin.v1.AdminListBatchesRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * @generated from field: string reference = 4;
   */
  reference: string;

  /**
   * @generated from field: optional bmi.v1.BatchStatus status = 5;
   */
  status?: BatchStatus | undefined;
};

/**
 * Describes the message wabms.admin.v1.AdminListBatchesRequest.
 * Use `create(AdminListBatchesRequestSchema)` to create a new message.
 */
export const AdminListBatchesRequestSchema: GenMessage<AdminListBatchesRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 48);

/**
 * @generated from message wabms.admin.v1.AdminListBatchesResponse
 */
export type AdminListBatchesResponse = Message<"wabms.admin.v1.AdminListBatchesResponse"> & {
  /**
   * @generated from field: repeated bmi.v1.Batch batches = 1;
   */
  batches: Batch[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wabms.admin.v1.AdminListBatchesResponse.
 * Use `create(AdminListBatchesResponseSchema)` to create a new message.
 */
export const AdminListBatchesResponseSchema: GenMessage<AdminListBatchesResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 49);

/**
 * @generated from message wabms.admin.v1.AdminGetBatchRequest
 */
export type AdminGetBatchRequest = Message<"wabms.admin.v1.AdminGetBatchRequest"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;
};

/**
 * Describes the message wabms.admin.v1.AdminGetBatchRequest.
 * Use `create(AdminGetBatchRequestSchema)` to create a new message.
 */
export const AdminGetBatchRequestSchema: GenMessage<AdminGetBatchRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 50);

/**
 * @generated from message wabms.admin.v1.AdminGetBatchResponse
 */
export type AdminGetBatchResponse = Message<"wabms.admin.v1.AdminGetBatchResponse"> & {
  /**
   * @generated from field: bmi.v1.Batch batch = 1;
   */
  batch?: Batch | undefined;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;
};

/**
 * Describes the message wabms.admin.v1.AdminGetBatchResponse.
 * Use `create(AdminGetBatchResponseSchema)` to create a new message.
 */
export const AdminGetBatchResponseSchema: GenMessage<AdminGetBatchResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 51);

/**
 * @generated from message wabms.admin.v1.AdminListMessagesRequest
 */
export type AdminListMessagesRequest = Message<"wabms.admin.v1.AdminListMessagesRequest"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * @generated from field: repeated bmi.v1.MessageState states = 4;
   */
  states: MessageState[];

  /**
   * Substring match on destination id or client_message_id.
   *
   * @generated from field: string search = 5;
   */
  search: string;
};

/**
 * Describes the message wabms.admin.v1.AdminListMessagesRequest.
 * Use `create(AdminListMessagesRequestSchema)` to create a new message.
 */
export const AdminListMessagesRequestSchema: GenMessage<AdminListMessagesRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 52);

/**
 * @generated from message wabms.admin.v1.AdminListMessagesResponse
 */
export type AdminListMessagesResponse = Message<"wabms.admin.v1.AdminListMessagesResponse"> & {
  /**
   * @generated from field: repeated bmi.v1.Message messages = 1;
   */
  messages: Message$1[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wabms.admin.v1.AdminListMessagesResponse.
 * Use `create(AdminListMessagesResponseSchema)` to create a new message.
 */
export const AdminListMessagesResponseSchema: GenMessage<AdminListMessagesResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 53);

/**
 * @generated from message wabms.admin.v1.MessageStateEvent
 */
export type MessageStateEvent = Message<"wabms.admin.v1.MessageStateEvent"> & {
  /**
   * @generated from field: int64 state_sequence = 1;
   */
  stateSequence: bigint;

  /**
   * @generated from field: bmi.v1.MessageState state = 2;
   */
  state: MessageState;

  /**
   * @generated from field: int32 attempt_count = 3;
   */
  attemptCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 4;
   */
  occurredAt?: Timestamp | undefined;

  /**
   * @generated from field: optional bmi.v1.MessageError error = 5;
   */
  error?: MessageError | undefined;
};

/**
 * Describes the message wabms.admin.v1.MessageStateEvent.
 * Use `create(MessageStateEventSchema)` to create a new message.
 */
export const MessageStateEventSchema: GenMessage<MessageStateEvent> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 54);

/**
 * @generated from message wabms.admin.v1.AdminGetMessageRequest
 */
export type AdminGetMessageRequest = Message<"wabms.admin.v1.AdminGetMessageRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;
};

/**
 * Describes the message wabms.admin.v1.AdminGetMessageRequest.
 * Use `create(AdminGetMessageRequestSchema)` to create a new message.
 */
export const AdminGetMessageRequestSchema: GenMessage<AdminGetMessageRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 55);

/**
 * @generated from message wabms.admin.v1.AdminGetMessageResponse
 */
export type AdminGetMessageResponse = Message<"wabms.admin.v1.AdminGetMessageResponse"> & {
  /**
   * @generated from field: bmi.v1.Message message = 1;
   */
  message?: Message$1 | undefined;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string target_message_id = 3;
   */
  targetMessageId: string;

  /**
   * @generated from field: string content_text = 4;
   */
  contentText: string;

  /**
   * Full audit trail, ordered by state_sequence ascending.
   *
   * @generated from field: repeated wabms.admin.v1.MessageStateEvent history = 5;
   */
  history: MessageStateEvent[];
};

/**
 * Describes the message wabms.admin.v1.AdminGetMessageResponse.
 * Use `create(AdminGetMessageResponseSchema)` to create a new message.
 */
export const AdminGetMessageResponseSchema: GenMessage<AdminGetMessageResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 56);

/**
 * @generated from message wabms.admin.v1.WebhookDelivery
 */
export type WebhookDelivery = Message<"wabms.admin.v1.WebhookDelivery"> & {
  /**
   * @generated from field: string delivery_id = 1;
   */
  deliveryId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string event_id = 3;
   */
  eventId: string;

  /**
   * @generated from field: string event_type = 4;
   */
  eventType: string;

  /**
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * @generated from field: int32 attempt = 6;
   */
  attempt: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp next_attempt_at = 7;
   */
  nextAttemptAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp delivered_at = 8;
   */
  deliveredAt?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp abandoned_at = 9;
   */
  abandonedAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 last_status = 10;
   */
  lastStatus: number;

  /**
   * @generated from field: string last_error = 11;
   */
  lastError: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message wabms.admin.v1.WebhookDelivery.
 * Use `create(WebhookDeliverySchema)` to create a new message.
 */
export const WebhookDeliverySchema: GenMessage<WebhookDelivery> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 57);

/**
 * @generated from message wabms.admin.v1.ListWebhookDeliveriesRequest
 */
export type ListWebhookDeliveriesRequest = Message<"wabms.admin.v1.ListWebhookDeliveriesRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Only deliveries that are neither delivered nor abandoned.
   *
   * @generated from field: bool pending_only = 4;
   */
  pendingOnly: boolean;
};

/**
 * Describes the message wabms.admin.v1.ListWebhookDeliveriesRequest.
 * Use `create(ListWebhookDeliveriesRequestSchema)` to create a new message.
 */
export const ListWebhookDeliveriesRequestSchema: GenMessage<ListWebhookDeliveriesRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 58);

/**
 * @generated from message wabms.admin.v1.ListWebhookDeliveriesResponse
 */
export type ListWebhookDeliveriesResponse = Message<"wabms.admin.v1.ListWebhookDeliveriesResponse"> & {
  /**
   * @generated from field: repeated wabms.admin.v1.WebhookDelivery deliveries = 1;
   */
  deliveries: WebhookDelivery[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wabms.admin.v1.ListWebhookDeliveriesResponse.
 * Use `create(ListWebhookDeliveriesResponseSchema)` to create a new message.
 */
export const ListWebhookDeliveriesResponseSchema: GenMessage<ListWebhookDeliveriesResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 59);

/**
 * @generated from message wabms.admin.v1.RetryWebhookDeliveryRequest
 */
export type RetryWebhookDeliveryRequest = Message<"wabms.admin.v1.RetryWebhookDeliveryRequest"> & {
  /**
   * @generated from field: string delivery_id = 1;
   */
  deliveryId: string;
};

/**
 * Describes the message wabms.admin.v1.RetryWebhookDeliveryRequest.
 * Use `create(RetryWebhookDeliveryRequestSchema)` to create a new message.
 */
export const RetryWebhookDeliveryRequestSchema: GenMessage<RetryWebhookDeliveryRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 60);

/**
 * @generated from message wabms.admin.v1.RetryWebhookDeliveryResponse
 */
export type RetryWebhookDeliveryResponse = Message<"wabms.admin.v1.RetryWebhookDeliveryResponse"> & {
  /**
   * @generated from field: wabms.admin.v1.WebhookDelivery delivery = 1;
   */
  delivery?: WebhookDelivery | undefined;
};

/**
 * Describes the message wabms.admin.v1.RetryWebhookDeliveryResponse.
 * Use `create(RetryWebhookDeliveryResponseSchema)` to create a new message.
 */
export const RetryWebhookDeliveryResponseSchema: GenMessage<RetryWebhookDeliveryResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 61);

/**
 * @generated from message wabms.admin.v1.GetStatsRequest
 */
export type GetStatsRequest = Message<"wabms.admin.v1.GetStatsRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * Look-back window in hours. Defaults to 24.
   *
   * @generated from field: int32 window_hours = 2;
   */
  windowHours: number;
};

/**
 * Describes the message wabms.admin.v1.GetStatsRequest.
 * Use `create(GetStatsRequestSchema)` to create a new message.
 */
export const GetStatsRequestSchema: GenMessage<GetStatsRequest> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 62);

/**
 * @generated from message wabms.admin.v1.GetStatsResponse
 */
export type GetStatsResponse = Message<"wabms.admin.v1.GetStatsResponse"> & {
  /**
   * MessageState value name -> count, over the window.
   *
   * @generated from field: map<string, int32> state_counts = 1;
   */
  stateCounts: { [key: string]: number };

  /**
   * @generated from field: int32 queue_depth = 2;
   */
  queueDepth: number;

  /**
   * @generated from field: int32 sent_today = 3;
   */
  sentToday: number;

  /**
   * @generated from field: int32 webhook_pending = 4;
   */
  webhookPending: number;

  /**
   * @generated from field: int32 webhook_abandoned = 5;
   */
  webhookAbandoned: number;
};

/**
 * Describes the message wabms.admin.v1.GetStatsResponse.
 * Use `create(GetStatsResponseSchema)` to create a new message.
 */
export const GetStatsResponseSchema: GenMessage<GetStatsResponse> = /*@__PURE__*/
  messageDesc(file_wabms_admin_v1_admin, 63);

/**
 * @generated from enum wabms.admin.v1.AccountStatus
 */
export enum AccountStatus {
  /**
   * @generated from enum value: ACCOUNT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Created but never successfully paired.
   *
   * @generated from enum value: ACCOUNT_STATUS_UNPAIRED = 1;
   */
  UNPAIRED = 1,

  /**
   * @generated from enum value: ACCOUNT_STATUS_CONNECTING = 2;
   */
  CONNECTING = 2,

  /**
   * @generated from enum value: ACCOUNT_STATUS_CONNECTED = 3;
   */
  CONNECTED = 3,

  /**
   * Transiently offline; whatsmeow is reconnecting. Messages keep queueing.
   *
   * @generated from enum value: ACCOUNT_STATUS_DISCONNECTED = 4;
   */
  DISCONNECTED = 4,

  /**
   * Unlinked from the phone. Requires re-pairing; in-flight messages fail.
   *
   * @generated from enum value: ACCOUNT_STATUS_LOGGED_OUT = 5;
   */
  LOGGED_OUT = 5,

  /**
   * WhatsApp rejected the connection. Sending is hard-paused.
   *
   * @generated from enum value: ACCOUNT_STATUS_BANNED = 6;
   */
  BANNED = 6,
}

/**
 * Describes the enum wabms.admin.v1.AccountStatus.
 */
export const AccountStatusSchema: GenEnum<AccountStatus> = /*@__PURE__*/
  enumDesc(file_wabms_admin_v1_admin, 0);

/**
 * @generated from enum wabms.admin.v1.PairMethod
 */
export enum PairMethod {
  /**
   * @generated from enum value: PAIR_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAIR_METHOD_QR = 1;
   */
  QR = 1,

  /**
   * Operator enters an 8-character code on their phone instead of scanning.
   *
   * @generated from enum value: PAIR_METHOD_PHONE_CODE = 2;
   */
  PHONE_CODE = 2,
}

/**
 * Describes the enum wabms.admin.v1.PairMethod.
 */
export const PairMethodSchema: GenEnum<PairMethod> = /*@__PURE__*/
  enumDesc(file_wabms_admin_v1_admin, 1);

/**
 * @generated from service wabms.admin.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * --- session -----------------------------------------------------------
   *
   * @generated from rpc wabms.admin.v1.AdminService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.WhoAmI
   */
  whoAmI: {
    methodKind: "unary";
    input: typeof WhoAmIRequestSchema;
    output: typeof WhoAmIResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.RevokeSession
   */
  revokeSession: {
    methodKind: "unary";
    input: typeof RevokeSessionRequestSchema;
    output: typeof RevokeSessionResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.RevokeAllSessions
   */
  revokeAllSessions: {
    methodKind: "unary";
    input: typeof RevokeAllSessionsRequestSchema;
    output: typeof RevokeAllSessionsResponseSchema;
  },
  /**
   * --- accounts ----------------------------------------------------------
   *
   * @generated from rpc wabms.admin.v1.AdminService.ListAccounts
   */
  listAccounts: {
    methodKind: "unary";
    input: typeof ListAccountsRequestSchema;
    output: typeof ListAccountsResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof GetAccountRequestSchema;
    output: typeof GetAccountResponseSchema;
  },
  /**
   * Server-streaming: emits a rotating QR code (or a phone linking code) until
   * the operator scans it, then a terminal paired/error update.
   *
   * @generated from rpc wabms.admin.v1.AdminService.PairAccount
   */
  pairAccount: {
    methodKind: "server_streaming";
    input: typeof PairAccountRequestSchema;
    output: typeof PairAccountUpdateSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.ReconnectAccount
   */
  reconnectAccount: {
    methodKind: "unary";
    input: typeof ReconnectAccountRequestSchema;
    output: typeof ReconnectAccountResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.DisconnectAccount
   */
  disconnectAccount: {
    methodKind: "unary";
    input: typeof DisconnectAccountRequestSchema;
    output: typeof DisconnectAccountResponseSchema;
  },
  /**
   * Unlinks the companion device on WhatsApp's side. Requires re-pairing.
   *
   * @generated from rpc wabms.admin.v1.AdminService.LogoutAccount
   */
  logoutAccount: {
    methodKind: "unary";
    input: typeof LogoutAccountRequestSchema;
    output: typeof LogoutAccountResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof DeleteAccountResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.UpdateSendPolicy
   */
  updateSendPolicy: {
    methodKind: "unary";
    input: typeof UpdateSendPolicyRequestSchema;
    output: typeof UpdateSendPolicyResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.UpdateWebhookConfig
   */
  updateWebhookConfig: {
    methodKind: "unary";
    input: typeof UpdateWebhookConfigRequestSchema;
    output: typeof UpdateWebhookConfigResponseSchema;
  },
  /**
   * Returns the new secret in plaintext exactly once.
   *
   * @generated from rpc wabms.admin.v1.AdminService.RotateWebhookSecret
   */
  rotateWebhookSecret: {
    methodKind: "unary";
    input: typeof RotateWebhookSecretRequestSchema;
    output: typeof RotateWebhookSecretResponseSchema;
  },
  /**
   * Lists the groups the account is a member of, live from WhatsApp. Requires
   * a connected account; nothing is cached server-side.
   *
   * @generated from rpc wabms.admin.v1.AdminService.ListGroups
   */
  listGroups: {
    methodKind: "unary";
    input: typeof ListGroupsRequestSchema;
    output: typeof ListGroupsResponseSchema;
  },
  /**
   * --- tokens ------------------------------------------------------------
   *
   * @generated from rpc wabms.admin.v1.AdminService.ListTokens
   */
  listTokens: {
    methodKind: "unary";
    input: typeof ListTokensRequestSchema;
    output: typeof ListTokensResponseSchema;
  },
  /**
   * Returns the token in plaintext exactly once; it is never recoverable after.
   *
   * @generated from rpc wabms.admin.v1.AdminService.CreateToken
   */
  createToken: {
    methodKind: "unary";
    input: typeof CreateTokenRequestSchema;
    output: typeof CreateTokenResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.RevokeToken
   */
  revokeToken: {
    methodKind: "unary";
    input: typeof RevokeTokenRequestSchema;
    output: typeof RevokeTokenResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.DeleteToken
   */
  deleteToken: {
    methodKind: "unary";
    input: typeof DeleteTokenRequestSchema;
    output: typeof DeleteTokenResponseSchema;
  },
  /**
   * --- traffic -----------------------------------------------------------
   *
   * @generated from rpc wabms.admin.v1.AdminService.ListBatches
   */
  listBatches: {
    methodKind: "unary";
    input: typeof AdminListBatchesRequestSchema;
    output: typeof AdminListBatchesResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.GetBatch
   */
  getBatch: {
    methodKind: "unary";
    input: typeof AdminGetBatchRequestSchema;
    output: typeof AdminGetBatchResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof AdminListMessagesRequestSchema;
    output: typeof AdminListMessagesResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.GetMessage
   */
  getMessage: {
    methodKind: "unary";
    input: typeof AdminGetMessageRequestSchema;
    output: typeof AdminGetMessageResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.ListWebhookDeliveries
   */
  listWebhookDeliveries: {
    methodKind: "unary";
    input: typeof ListWebhookDeliveriesRequestSchema;
    output: typeof ListWebhookDeliveriesResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.RetryWebhookDelivery
   */
  retryWebhookDelivery: {
    methodKind: "unary";
    input: typeof RetryWebhookDeliveryRequestSchema;
    output: typeof RetryWebhookDeliveryResponseSchema;
  },
  /**
   * @generated from rpc wabms.admin.v1.AdminService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof GetStatsRequestSchema;
    output: typeof GetStatsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wabms_admin_v1_admin, 0);

